/* eslint-disable import/no-extraneous-dependencies */
import Vue from 'vue';
import VCalendar from 'v-calendar';
import VModal from 'vue-js-modal';
import VueToast from 'vue-toast-notification';
import AldNotification from 'plugins/Notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';

Vue.use(VModal);
Vue.use(VueToast, {
  position: 'top-right',
  duration: 5000
}); // https://github.com/ankurk91/vue-toast-notification/tree/v1.x
Vue.use(AldNotification);
Vue.use(VCalendar);

// eslint-disable-next-line import/no-extraneous-dependencies
import(/* webpackChunkName: "components/vue-awesome-swiper" */ 'vue-awesome-swiper').then(
  ({ swiper, swiperSlide }) => {
    Vue.component('swiper', swiper);
    Vue.component('swiper-slide', swiperSlide);
  }
);

// See documentation: https://bootstrap-vue.js.org/docs/components/table
Vue.component('b-table', () =>
  import(/* webpackChunkName: "components/bootstrap-vue/table" */ 'bootstrap-vue').then(
    ({ BTable }) => BTable
  )
);

// Register Ald Automotive components, they start with 'ald-', example: ald-accordion
Vue.component('ald-accordion', () =>
  import(/* webpackChunkName: "components/ald-accordion" */ 'components/Accordion')
);
Vue.component('ald-alert', () =>
  import(/* webpackChunkName: "components/ald-alert" */ 'components/Alert')
);
Vue.component('ald-badge', () =>
  import(/* webpackChunkName: "components/ald-badge" */ 'components/Badge')
);
Vue.component('ald-button', () =>
  import(/* webpackChunkName: "components/ald-button" */ 'components/Button')
);
Vue.component('ald-button-group', () =>
  import(/* webpackChunkName: "components/ald-button-group" */ 'components/ButtonGroup')
);
Vue.component('ald-card', () =>
  import(/* webpackChunkName: "components/ald-card" */ 'components/Card')
);
Vue.component('ald-checkbox', () =>
  import(/* webpackChunkName: "components/ald-checkbox" */ 'components/Checkbox')
);
Vue.component('ald-check-list', () =>
  import(/* webpackChunkName: "components/ald-check-list" */ 'components/CheckList')
);
Vue.component('ald-collapse', () =>
  import(/* webpackChunkName: "components/ald-collapse" */ 'components/Collapse')
);
Vue.component('ald-fineuploader', () =>
  import(/* webpackChunkName: "components/ald-fineuploader" */ 'components/Fineuploader')
);
Vue.component('ald-icon', () =>
  import(/* webpackChunkName: "components/ald-icon" */ 'components/Icon')
);
Vue.component('ald-input', () =>
  import(/* webpackChunkName: "components/ald-input" */ 'components/Input')
);
Vue.component('ald-legal-conditions', () =>
  import(/* webpackChunkName: "components/ald-legal-conditions" */ 'components/LegalConditions')
);
Vue.component('ald-loader', () =>
  import(/* webpackChunkName: "components/ald-loader" */ 'components/Loader')
);
Vue.component('ald-markdown', () =>
  import(/* webpackChunkName: "components/ald-markdown" */ 'components/Markdown')
);
Vue.component('ald-modal', () =>
  import(/* webpackChunkName: "components/ald-modal" */ 'components/Modal')
);
Vue.component('ald-radio', () =>
  import(/* webpackChunkName: "components/ald-radio" */ 'components/Radios/Radio')
);
Vue.component('ald-radios', () =>
  import(/* webpackChunkName: "components/ald-radios" */ 'components/Radios')
);
Vue.component('ald-select', () =>
  import(/* webpackChunkName: "components/ald-select" */ 'components/Select')
);
Vue.component('ald-text', () =>
  import(/* webpackChunkName: "components/ald-text" */ 'components/Text')
);
Vue.component('ald-textarea', () =>
  import(/* webpackChunkName: "components/ald-text" */ 'components/Textarea')
);
Vue.component('ald-transition', () =>
  import(/* webpackChunkName: "components/ald-transition" */ 'components/Transition')
);
Vue.component('ald-doc-validation', () =>
  import(/* webpackChunkName: "components/ald-doc-validation" */ 'components/DocValidation')
);
Vue.component('ald-fineviewer', () =>
  import(/* webpackChunkName: "components/ald-fineviewer" */ 'components/Fineviewer')
);
Vue.component('ald-maps', () =>
  import(/* webpackChunkName: "components/ald-maps" */ 'components/Maps')
);
Vue.component('ald-tabs', () =>
  import(/* webpackChunkName: "components/ald-tabs" */ 'components/Tabs')
);
Vue.component('ald-tab', () =>
  import(/* webpackChunkName: "components/ald-tabs" */ 'components/Tabs/Tab')
);
Vue.component('ald-code-slider', () =>
  import(/* webpackChunkName: "components/ald-code-slider" */ 'components/CodeSlider')
);
Vue.component('ald-chart', () =>
  import(/* webpackChunkName: "components/ald-charts/chart" */ 'components/Chart')
);

Vue.component('car-fuel-table', () =>
  import(/* webpackChunkName: "components/car-fuel-table" */ 'components/CarFuelTable')
);
Vue.component('ald-image-uploader', () =>
  import(/* webpackChunkName: "components/ald-image-uploader" */ 'components/ImageUploader')
);
Vue.component('ald-file-uploader', () =>
  import(/* webpackChunkName: "components/ald-file-uploader" */ 'components/FileUploader')
);

Vue.component('ald-link', () =>
  import(/* webpackChunkName: "components/ald-link" */ 'components/Link')
);
Vue.component('ald-bar-actions', () =>
  import(/* webpackChunkName: "components/ald-bar-actions" */ 'components/BarActions')
);
Vue.component('ald-grid', () =>
  import(/* webpackChunkName: "components/my-ald/grid" */ 'components/MyAld/Grid')
);
Vue.component('ald-main-content', () =>
  import(/* webpackChunkName: "components/my-ald/main-content" */ 'components/MyAld/MainContent')
);
Vue.component('ald-auth-content', () =>
  import(/* webpackChunkName: "components/my-ald/auth-content" */ 'components/MyAld/AuthContent')
);
Vue.component('ald-calendar', () =>
  import(/* webpackChunkName: "components/Calendar" */ 'components/Calendar')
);
